"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectContainer = exports.StyledControl = void 0;
var react_1 = __importStar(require("react"));
var react_select_1 = __importStar(require("react-select"));
var styled_components_1 = __importStar(require("styled-components"));
var hooks_1 = require("../../../hooks");
var useDebounce_1 = __importDefault(require("../../../hooks/useDebounce"));
var fields_1 = require("../fields");
var utils_1 = require("../utils");
var StyledSelect = styled_components_1.default(react_select_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var $hasError = _a.$hasError;
    return $hasError && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-radius: 4px;\n      border: 2px solid #ba0d23;\n    "], ["\n      border-radius: 4px;\n      border: 2px solid #ba0d23;\n    "])));
});
var customStyles = {
    placeholder: function () { return ({
        color: '#3b3b3b',
        opacity: 0.5,
        fontSize: 15,
        letterSpacing: '0.012em',
        lineHeight: '24px',
        maxWidth: '370px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    }); },
    control: function (provided) { return (__assign(__assign({}, provided), { fontSize: 15, border: '1px solid #686868', borderRadius: '3px !important', '&:hover': {
            borderColor: '#686868',
        }, '&:focus': {
            border: '2px solid #686868',
        } })); },
};
var RightIconWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-right: 10px;\n  font-size: 12px;\n"], ["\n  margin-right: 10px;\n  font-size: 12px;\n"])));
var StyledOption = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border-bottom: 1px solid #e5ebf0;\n  cursor: pointer;\n  padding: 1em 1em;\n  font-size: 15px;\n  &:hover {\n    background: #eee;\n  }\n\n  ", "\n"], ["\n  border-bottom: 1px solid #e5ebf0;\n  cursor: pointer;\n  padding: 1em 1em;\n  font-size: 15px;\n  &:hover {\n    background: #eee;\n  }\n\n  ",
    "\n"])), function (_a) {
    var $selected = _a.$selected;
    return $selected && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      background: #eee;\n    "], ["\n      background: #eee;\n    "])));
});
var StyledLeftIcon = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-left: 10px;\n  display: flex;\n"], ["\n  margin-left: 10px;\n  display: flex;\n"])));
exports.StyledControl = styled_components_1.default(react_select_1.components.Control)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: 50px;\n"], ["\n  height: 50px;\n"])));
var Option = function (_a) {
    var innerRef = _a.innerRef, innerProps = _a.innerProps, data = _a.data;
    return (react_1.default.createElement(StyledOption, __assign({ ref: innerRef }, innerProps, { "$selected": innerRef }), data.render || data.label));
};
var Control = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var leftIcon = props.selectProps.leftIcon;
    return (react_1.default.createElement(exports.StyledControl, __assign({}, props),
        leftIcon && react_1.default.createElement(StyledLeftIcon, null, leftIcon),
        children));
};
exports.SelectContainer = styled_components_1.default(react_select_1.components.SelectContainer)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var selectProps = _a.selectProps;
    return utils_1.getInputSizeStyles(selectProps.size);
});
function Dropdown(_a) {
    var _this = this;
    var defaultOption = _a.defaultOption, size = _a.size, placeholder = _a.placeholder, value = _a.value, onChange = _a.onChange, loadOptions = _a.loadOptions, isSearchable = _a.isSearchable, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, hasError = _a.hasError, readOnly = _a.readOnly, enableReset = _a.enableReset, inputId = _a.inputId, maxMenuHeight = _a.maxMenuHeight, menuPlacement = _a.menuPlacement, disabled = _a.disabled;
    var _b = react_1.useState([]), options = _b[0], setOptions = _b[1];
    var _c = react_1.useState(), selectedOption = _c[0], setSelectedOption = _c[1];
    var isLoading = hooks_1.useBoolean(false);
    var _d = react_1.useState(), search = _d[0], setSearch = _d[1];
    var _e = useDebounce_1.default(search), isDebouncing = _e.isDebouncing, debouncedValue = _e.debouncedValue;
    var resetValue = { value: -1, label: 'Zrušit výběr' };
    var loading = isDebouncing || isLoading.value;
    var pridatReset = function (opt) {
        if (enableReset) {
            if (!opt.find(function (o) { return o.value === resetValue.value; })) {
                setOptions(__spreadArrays([resetValue], opt));
                return;
            }
        }
        setOptions(opt);
    };
    var odebratReset = function (val) {
        if (val.value === -1) {
            var newOptions = options.filter(function (o) { return o.value !== resetValue.value; });
            setOptions(newOptions);
            setSearch(undefined);
            return {};
        }
        return val;
    };
    var fetchOptions = function () { return __awaiter(_this, void 0, void 0, function () {
        var o;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!loadOptions) return [3 /*break*/, 2];
                    isLoading.setTrue();
                    return [4 /*yield*/, loadOptions(search)];
                case 1:
                    o = _a.sent();
                    if (selectedOption)
                        pridatReset(o);
                    else
                        setOptions(o);
                    isLoading.setFalse();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var change = function (o) {
        pridatReset(options);
        var val = odebratReset(o);
        if (!isSearchable)
            setSearch(undefined);
        return onChange ? onChange(val.value, val) : {};
    };
    react_1.useEffect(function () {
        fetchOptions();
    }, [debouncedValue]);
    react_1.useEffect(function () {
        setSelectedOption(options.find(function (o) { return o.value === value; }) || null);
    }, [options, value]);
    react_1.useEffect(function () {
        if (defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.option)
            fetchOptions();
        if (defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.selected)
            setSelectedOption(options.find(function (o) { return o.value === (defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.selected); }) || null);
    }, [defaultOption]);
    var filterOptions = function (o) {
        if (o.value === -1)
            return true;
        return o.label.toLowerCase().startsWith(search === null || search === void 0 ? void 0 : search.toLocaleLowerCase());
    };
    return (react_1.default.createElement(StyledSelect, { inputId: inputId, styles: customStyles, size: size, onInputChange: function (v, _a) {
            var action = _a.action;
            if (action === 'input-change') {
                setSearch(v);
            }
        }, onFocus: fetchOptions, onBlur: function () {
            if (!value || !isSearchable) {
                setSearch(undefined);
            }
        }, "$hasError": hasError, leftIcon: leftIcon, readOnly: readOnly, value: selectedOption, placeholder: placeholder || '', isLoading: loading, options: options, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, filterOption: isSearchable || !(search === null || search === void 0 ? void 0 : search.length) ? false : function (o) { return filterOptions(o); }, onChange: function (o) { return change(o); }, noOptionsMessage: function (_a) {
            var inputValue = _a.inputValue;
            if (inputValue) {
                return 'Žádná data';
            }
            return null;
        }, loadingMessage: function () {
            return 'Načítání';
        }, isSearchable: true, components: {
            Control: Control,
            Option: Option,
            SelectContainer: exports.SelectContainer,
            IndicatorSeparator: null,
            DropdownIndicator: function () { return react_1.default.createElement(RightIconWrapper, null, readOnly ? react_1.default.createElement("span", null) : rightIcon || react_1.default.createElement(fields_1.CaretDown, null)); },
        }, theme: function (theme) { return (__assign(__assign({}, theme), { colors: __assign(__assign({}, theme.colors), { primary: '#2362a2' }) })); }, isDisabled: disabled }));
}
Dropdown.defaultProps = {
    onSearch: undefined,
    onSelect: undefined,
    value: undefined,
    options: undefined,
    loading: false,
    placeholder: undefined,
    leftIcon: undefined,
    searchIcon: false,
    hasError: false,
    isSearchable: false,
    controlStyles: {},
    size: undefined,
    readOnly: false,
    enableReset: false,
    maxMenuHeight: undefined,
    menuPlacement: undefined,
    disabled: false,
};
exports.default = Dropdown;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
